import type { ListingTemplate } from '@/api/listings'

/**
 * Saved field presets (pivot doc §6 Stage 3, Templates screen). Generic
 * starting points for a new listing's prize details — no tenant is named, so
 * the same set applies under every demo tenant.
 */
export const LISTING_TEMPLATES: readonly ListingTemplate[] = [
  {
    id: 'tpl_cash',
    name: 'Cash jackpot',
    description: 'A straightforward tax-free cash prize, priced for high volume.',
    prize: {
      prizeName: '£5,000 Tax-Free Cash',
      prizeCategory: 'Cash',
      prizeValue: 5000,
      ticketPrice: 0.99,
      maxEntries: 6000,
      instantWinsCount: 5,
      mainImageUrl: '',
      additionalMediaUrls: [],
      keySellingPoints: ['Tax-free cash prize', 'Instant wins available', 'Winner drawn live on camera'],
      prizeSpecifications: 'Cash paid by bank transfer within 7 days of the draw.',
    },
  },
  {
    id: 'tpl_motoring',
    name: 'Motoring',
    description: 'A car or bike prize with finance-value framing.',
    prize: {
      prizeName: 'Dream Car',
      prizeCategory: 'Motoring',
      prizeValue: 32000,
      ticketPrice: 2.49,
      maxEntries: 9000,
      instantWinsCount: 0,
      mainImageUrl: '',
      additionalMediaUrls: [],
      keySellingPoints: ['Brand new, delivered to your door', 'Road tax and first year insurance included'],
      prizeSpecifications: 'Vehicle registered and delivered within 28 days of the draw, or £25,000 cash alternative.',
    },
  },
  {
    id: 'tpl_tech',
    name: 'Tech bundle',
    description: 'A flagship device plus accessories, for a younger audience.',
    prize: {
      prizeName: 'Ultimate Tech Bundle',
      prizeCategory: 'Tech',
      prizeValue: 2200,
      ticketPrice: 0.79,
      maxEntries: 5000,
      instantWinsCount: 10,
      mainImageUrl: '',
      additionalMediaUrls: [],
      keySellingPoints: ['Latest flagship device', 'Accessory bundle included', '10 instant wins along the way'],
      prizeSpecifications: 'Devices shipped new, sealed, with full manufacturer warranty.',
    },
  },
  {
    id: 'tpl_getaway',
    name: 'Luxury getaway',
    description: 'A travel prize with flexible dates.',
    prize: {
      prizeName: 'Luxury Getaway for Two',
      prizeCategory: 'Travel',
      prizeValue: 4500,
      ticketPrice: 1.49,
      maxEntries: 3000,
      instantWinsCount: 0,
      mainImageUrl: '',
      additionalMediaUrls: [],
      keySellingPoints: ['Flights and 5-star accommodation included', 'Book any date within 12 months'],
      prizeSpecifications: 'Travel voucher issued within 14 days of the draw, valid for 12 months.',
    },
  },
]
